import { render, staticRenderFns } from "./Judgeme.vue?vue&type=template&id=26eda210&scoped=true"
import script from "./Judgeme.vue?vue&type=script&lang=js"
export * from "./Judgeme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eda210",
  null
  
)

export default component.exports